export default {

    PROJECT: 'PROJECT',
    PROJECT_REPORT: 'PROJECT_REPORT',
    CONTACT: 'CONTACT',

}
